import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { isPermissionAllowed } from './permission-check';
import { redirectAndShowNotAllowedNotification } from './redirect';

export const permissionOrRedirect = (): void => {
  onMounted(async () => {
    const route = useRoute();

    if (!isPermissionAllowed(route.meta)) {
      redirectAndShowNotAllowedNotification(0);
    }
  });
};
